import React from 'react';
import {useTranslation} from 'react-i18next';
import { Route, Routes } from 'react-router-dom'
import {CardContainer} from "../../Components/Card/Card";
import EducationCodeContainer from "./EducationCodeContainer";
import SentMoviesContainer from "./SentMoviesContainer";
import CourseContainer from "./Educations/CourseContainer";
import OnboardingTestContainer from "./Educations/OnboardingContainer";

function EducationsLayout ({ }){
    const { t } = useTranslation();
    
        return(
            <CardContainer>
                <Routes>
                    <Route path={'courses/*'} element={<CourseContainer />} />
                    <Route path={'onboardings/*'} element={<OnboardingTestContainer/>} />
                    <Route path={'education-code/*'} element={<EducationCodeContainer />} />
                    <Route path={'movies/*'} element={<SentMoviesContainer/>}/>
                </Routes>
            </CardContainer>
        )
}

export default EducationsLayout;